<template>
  <v-card>
    <v-card-title class="text-h6" style="padding: 10px 10px 10px">
      {{ $t("Phát sinh") }}
    </v-card-title>

    <v-card-text style="padding: 10px">
      <template v-if="step == 1">
        <v-simple-table
          class="table-padding-2 table-h-36"
          v-if="indemnifyItems.length > 0 || settlement.overdue_amount > 0"
        >
          <template v-slot:default>
            <thead class="v-data-table-header">
              <tr>
                <th role="columnheader" class="text-center">Tài sản</th>
                <th
                  role="columnheader"
                  class="text-center"
                  style="width: 60px; min-width: 60px"
                >
                  Phân loại
                </th>
                <th role="columnheader" class="text-center">Bồi thường</th>
                <th role="columnheader" class="text-center">Ghi chú</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="item in indemnifyItems"
                :key="`idm_${item.id}`"
              >
                <td>{{ item.name }} - {{ item.asset_type_name }}</td>
                <td style="width: 60px; min-width: 60px">
                  {{ !item.is_scanned ? "Mất" : "Hư hại" }}
                </td>
                <td>
                  <span v-if="!item.is_scanned">
                    {{ formatNumber(item.indemnify_price) }}đ
                  </span>
                  <input-number
                    v-else-if="!!item.is_damage"
                    v-model.number="item.indemnify_amount"
                    type="number"
                    outlined
                    dense
                    hide-details
                    class="c-input-small"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="item.note"
                    class="c-input-small"
                    outlined
                    dense
                    hide-details
                    single-line
                  ></v-text-field>
                </td>
              </tr>
              <tr class="text-center purple--text">
                <td>#</td>
                <td style="width: 60px; min-width: 60px">
                  {{ $t("Quá hạn") }}
                </td>
                <td>{{ formatNumber(settlement.overdue_amount) }}đ</td>
                <td>{{ settlement.overdue_hour }} giờ</td>
              </tr>
              <tr class="text-center error--text font-weight-medium">
                <td colspan="2">Cần thanh toán</td>
                <td colspan="2">{{ formatNumber(summary.total_amount) }}đ</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div v-else>
          Đơn hàng không có phát sinh. <br />
          Bấm xác nhận để hoàn thành trả xe!
        </div>
      </template>
      <template v-else>
        <div class="mb-5 d-flex align-center justify-center">
          <v-radio-group
            v-model="payment.payment_method"
            hide-details
            class="c-input-small w-100"
            @change="onPaymentMethodChanged"
          >
            <v-row dense>
              <v-col cols="6">
                <v-radio label="Chuyển khoản" :value="1"></v-radio>
              </v-col>
              <v-col cols="6">
                <v-radio label="Quẹt thẻ" :value="2"></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </div>

        <div class="text-center">
          <div v-if="qrString && payment.payment_method == 1">
            <qrcode-vue
              :value="qrString"
              :size="150"
              level="L"
              id="paymentQrCode"
            ></qrcode-vue>
            <div class="mb-1">
              <span
                class="qr-download-icon cursor-pointer primary--text text-decoration-underline"
                @click="downloadQrPayment"
              >
                QR download
              </span>
            </div>
          </div>
          <div v-else>
            <div class="emove-loader mx-auto my-5"></div>
            <div class="primary--text">Chờ quẹt thẻ</div>
          </div>
          <div class="fs-16px font-weight-medium error--text">
            {{ formatNumber(payment.total_amount) }} VND
          </div>
        </div>
      </template>
    </v-card-text>

    <v-card-actions>
      <v-row dense>
        <v-col :cols="step == 1 || settlement.id_delivery_request > 0 ? 6 : 12">
          <v-btn color="error" block small @click="close">
            {{ $t("Đóng") }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <template v-if="step == 1">
            <v-btn
              color="primary"
              block
              small
              @click="confirmSettlement"
              v-if="indemnifyItems.length > 0 || settlement.overdue_amount > 0"
            >
              {{ $t("Tiếp") }}
            </v-btn>
            <v-btn
              color="success"
              block
              small
              @click="confirmSettlement"
              v-else
            >
              {{ $t("Xác nhận") }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              color="purple"
              class="white--text"
              block
              small
              @click="finishSettlement"
              v-if="settlement.id_delivery_request > 0"
            >
              {{ $t("Thanh toán sau") }}
            </v-btn>
          </template>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { httpClient } from "@/libs/http";
import QrcodeVue from "qrcode.vue";

export default {
  name: "DialogConfirm",
  components: {
    QrcodeVue,
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    settlement: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    indemnifyItems: [],
    step: 1,
    payment: {},
    qrString: null,
  }),
  computed: {
    summary() {
      const indemnify_item = this.indemnifyItems && this.indemnifyItems.length;
      let indemnify_amount = 0;

      if (this.indemnifyItems && this.indemnifyItems.length > 0) {
        for (let i = 0; i < this.indemnifyItems.length; i++) {
          const item = this.indemnifyItems[i];
          if (!item.is_scanned) {
            indemnify_amount += +item.indemnify_price;
          } else {
            indemnify_amount += +item.indemnify_amount;
          }
        }
      }

      return {
        indemnify_item,
        indemnify_amount,
        total_amount: indemnify_amount + +this.settlement.overdue_amount,
      };
    },
  },
  mounted() {
    this.indemnifyItems = [...this.items].filter(
      (item) => !item.is_scanned || !!item.is_damage
    );
  },
  methods: {
    close() {
      this.$emit("close", true);
    },

    onFinish() {
      this.$emit("onFinish", true);
    },

    async onPaymentMethodChanged() {
      await httpClient.post("/payment/v1/set-wait-payment-method", {
        id_order: this.payment.id_order,
        id_branch: this.payment.id_branch,
        payment_method: this.payment.payment_method,
      });
    },

    async getQr() {
      if (!this.payment.id_order) {
        return false;
      }
      const { data } = await httpClient.post("/order/v1/get-payment-qr", {
        id_order: this.payment.id_order,
      });
      this.qrString = data;
    },

    async confirmSettlement() {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        const { data } = await httpClient.post(
          "/order/v1/settlement-save-item",
          {
            items: this.indemnifyItems,
          }
        );

        this.isLoading = false;

        document.getElementById("success_sound_player").play();

        if (data.total_amount > 0) {
          this.payment = {
            ...data,
            payment_method: 2,
          };
          this.getQr();
          this.onPaymentMethodChanged();
          this.step = 2;
        } else {
          this.onFinish();
        }
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },

    async finishSettlement() {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        await httpClient.post("/order/v1/settlement-finish", {
          id_order: this.order.id,
        });

        this.isLoading = false;

        document.getElementById("success_sound_player").play();

        this.onFinish();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
